import React from "react";
import GameCard from "../components/GameCard";
const GAMES = require("../data/games.json");

function HeroBanner() {
    const top_game = Object.values(GAMES).sort((a, b) => b.rating - a.rating)[0];
    return (
        <div className="relative bg-yellow-600/50 overflow-hidden rounded-b-3xl">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                    <div>
                        <h1 className="text-4xl md:text-5xl font-extrabold text-black">Semperor Games</h1>
                        <p className="mt-4 text-black max-w-xl text-justify">Semperor Games is a creative mobile game developer and publisher focused on delivering engaging, high-quality entertainment experiences for global audiences. With a passion for innovation and player satisfaction, Semperor Games specializes in designing fun, accessible, and visually appealing titles that combine strong gameplay with cultural and emotional depth. The studio’s mission is to connect players through memorable gaming moments while supporting talented developers to bring their ideas to life.</p>
                        <div className="mt-6 flex gap-3">
                            {/* <Link to="/" className="px-4 py-2 rounded-full bg-blue-600 hover:bg-blue-700">Browse games</Link>
                            <a href="#" className="px-4 py-2 rounded-full border border-white/10">Upload game</a> */}
                        </div>
                    </div>
                    {/* <Link to= className="group block bg-gradient-to-br from-[#021428] to-[#011428] rounded-xl overflow-hidden shadow-md hover:shadow-xl transform hover:-translate-y-1 transition"> */}
                    <div className="hidden sm:block">
                        <div className="bg-gradient-to-br from-yellow-600 to-yellow-900 p-4 rounded-2xl shadow-xl">
                            <img src="/images/hero-banner.png" alt="preview" className="w-full object-cover rounded-md" />
                            <div className="mt-3 text-black font-semibold text-center">Discover the Future of Mobile Gaming</div>
                            <div className="text-balck text-sm text-center">★ ★ ★</div>
                        </div>
                    </div>
                    {/* </Link> */}
                </div>
            </div>
        </div>
    );
}

function Home() {
    return (
        <div className="pt-20 pb-24">
            <HeroBanner />
            <main className="w-full">
                <section className="mt-12 w-full">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <h2 className="text-2xl font-semibold text-black">Popular Games</h2>
                        <p className="text-balck mt-2">Discover and download top mobile titles — curated picks every week.</p>
                    </div>

                    <div className="mt-6 w-full">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full">
                                {Object.values(GAMES).map((g) => (
                                    <GameCard key={g.id} game={g} />
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}

export default Home;